<ng-container
  [ngTemplateOutlet]="
    simple ? simplePagination : simpleWithInfo ? simpleWithInfoPagination : defaultPagination
  "
></ng-container>

<ng-template #simplePagination>
  @if (internalPage != null) {
    <div class="portal-pagination portal-pagination--simple btn-group">
      <button
        [class]="'btn btn-outline-secondary btn-' + buttonSize"
        [disabled]="disabled || internalPage.page <= 1"
        [portalTippy]="'common.pagination.previous' | translate"
        (click)="selectPage('previous')"
        appendTo="body"
        type="button"
      >
        <i class="far fa-angle-left fa-fw"></i>
      </button>
      <button
        [class]="'btn btn-outline-secondary btn-' + buttonSize"
        [disabled]="disabled || internalPage.page >= internalPage.pages"
        [portalTippy]="'common.pagination.next' | translate"
        (click)="selectPage('next')"
        appendTo="body"
        type="button"
      >
        <i class="far fa-angle-right fa-fw"></i>
      </button>
    </div>
  }
</ng-template>

<ng-template #simpleWithInfoPagination>
  <div class="portal-pagination">
    <div class="portal-pagination__description">
      {{
        description
          | translate
            : {
                filtered: internalPage!.filtered,
                from: internalPage!.from,
                to: internalPage!.to,
                total: internalPage!.total,
              }
      }}
    </div>

    @if (internalPage.pages > 1) {
      <div class="portal-pagination__toggles btn-group" role="group">
        <button
          [class]="'btn btn-outline-secondary btn-' + buttonSize"
          [disabled]="disabled || internalPage.page <= 1"
          [portalTippy]="'common.pagination.previous' | translate"
          (click)="selectPage('previous')"
          appendTo="body"
          type="button"
        >
          <i class="far fa-angle-left fa-fw"></i>
        </button>
        <button
          [class]="'btn btn-outline-secondary btn-' + buttonSize"
          [disabled]="disabled || internalPage.page >= internalPage.pages"
          [portalTippy]="'common.pagination.next' | translate"
          (click)="selectPage('next')"
          appendTo="body"
          type="button"
        >
          <i class="far fa-angle-right fa-fw"></i>
        </button>
      </div>
    }
  </div>
</ng-template>

<ng-template #defaultPagination>
  <div class="portal-pagination">
    <div class="portal-pagination__description">
      @if (internalPage.filtered !== internalPage.total) {
        {{
          description
            | translate
              : {
                  total: internalPage.filtered,
                  from: internalPage.from,
                  to: internalPage.to,
                }
        }}
        {{ 'common.pagination.description.filtered' | translate: { total: internalPage.total } }}
      } @else {
        {{
          description
            | translate
              : {
                  total: internalPage.filtered,
                  from: internalPage.from,
                  to: internalPage.to,
                }
        }}
      }

      @if (selected != null) {
        <div>
          {{
            selected
              | i18nPlural
                : {
                    '=0': 'common.pagination.selected.none',
                    '=1': 'common.pagination.selected.one',
                    other: 'common.pagination.selected.many',
                  }
              | portalTranslate: { count: selected }
          }}
        </div>
      }
    </div>

    <div class="portal-pagination__toggles btn-group" [hidden]="hideControls" role="group">
      <button
        [class]="'btn btn-outline-secondary btn-' + buttonSize"
        [disabled]="disabled || internalPage.page <= 1"
        [portalTippy]="'common.pagination.first' | translate"
        (click)="selectPage('first')"
        appendTo="body"
        type="button"
      >
        <i class="far fa-angle-double-left fa-fw"></i>
      </button>

      <button
        [class]="'btn btn-outline-secondary btn-' + buttonSize"
        [disabled]="disabled || internalPage.page <= 1"
        [portalTippy]="'common.pagination.previous' | translate"
        (click)="selectPage('previous')"
        appendTo="body"
        type="button"
      >
        <i class="far fa-angle-left fa-fw"></i>
      </button>

      <button
        #p="ngbPopover"
        [autoClose]="'outside'"
        [class]="'btn btn-outline-secondary btn-' + buttonSize"
        [ngbPopover]="popover"
        [popoverTitle]="'common.pagination.settings' | translate"
        [portalTippy]="'common.pagination.settings' | translate"
        [tippyDisabled]="p.isOpen()"
        appendTo="body"
        type="button"
      >
        <i class="far fa-cog fa-fw"></i>
      </button>

      <button
        [class]="'btn btn-outline-secondary btn-' + buttonSize"
        [disabled]="disabled || internalPage.page >= internalPage.pages"
        [portalTippy]="'common.pagination.next' | translate"
        (click)="selectPage('next')"
        appendTo="body"
        type="button"
      >
        <i class="far fa-angle-right fa-fw"></i>
      </button>

      <button
        [class]="'btn btn-outline-secondary btn-' + buttonSize"
        [disabled]="disabled || internalPage.page >= internalPage.pages"
        [portalTippy]="'common.pagination.last' | translate"
        (click)="selectPage('last')"
        appendTo="body"
        type="button"
      >
        <i class="far fa-angle-double-right fa-fw"></i>
      </button>
    </div>

    <ng-template #popover>
      <form class="form" [formGroup]="form">
        <div class="form-group">
          <label class="form-label">{{ 'page' | translate }}</label>
          <div class="input-group">
            <input
              class="form-control"
              [max]="internalPage.pages"
              autocomplete="off"
              formControlName="page"
              min="1"
              type="number"
            />

            <span class="input-group-text"
              >{{ 'common.pagination.of' | translate }} {{ internalPage.pages }}</span
            >
          </div>
        </div>
        <div class="form-group">
          <label class="form-label" for="pageSize">{{ 'perPage' | translate }}</label>
          <ng-select
            class="flex-grow-1"
            id="pageSize"
            [clearable]="false"
            (change)="onPageSizeChanged()"
            formControlName="pageSize"
            name="pageSize"
          >
            @for (step of steps; track step) {
              <ng-option [value]="step">{{ step }}</ng-option>
            }
            <ng-option [value]="MAX">{{ 'generic.showAll' | translate }}</ng-option>
          </ng-select>
        </div>
      </form>
    </ng-template>
  </div>
</ng-template>
